"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductionTime = void 0;

var _request = _interopRequireDefault(require("../../PricingGrid/services/request"));

var getProductionTime = function getProductionTime(mcpSku, onGetAccessToken) {
  return (0, _request.default)("https://productiontime.dnj.cimpress.io/v2/ProductionTime/McpSku/".concat(mcpSku), onGetAccessToken);
};

exports.getProductionTime = getProductionTime;